/// <amd-module name="Repos/Views/Import/Components/PanelClone/PanelClone" />
import * as React from "react";

import { ObservableValue } from "VSS/Core/Observable";

import { FormItem } from "VSSUI/FormItem";
import { Panel } from "VSSUI/Panel";

import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { RepoProtocol } from "Repos/Common/Types";
import { IVCViewModelDataProviderService } from "Repos/Common/VCViewModelDataProviderService";

import { CloneNotice, CloneWithApplication, CloneWithCredential } from "Repos/Views/Import/Clone";
import * as Resources from "Repos/Views/Import/Resources";
import { PanelCloneProps } from "./PanelClone.Props";

export class PanelClone extends VssComponent<PanelCloneProps> {
    private protocol: ObservableValue<RepoProtocol>;

    constructor(props: PanelCloneProps, context: IVssComponentContext) {
        super(props, context);

        const vcViewModelDataProviderService = context.pageContext.getService<IVCViewModelDataProviderService>("IVCViewModelDataProviderService");
        const vcViewModel = vcViewModelDataProviderService.getViewModel();

        // If https is available we will use this protocol by default.
        this.protocol = new ObservableValue<RepoProtocol>(vcViewModel.cloneUrl ? RepoProtocol.https : RepoProtocol.ssh);
    }

    public render() {
        return (
            <Panel
                className="panel-clone"
                defaultActiveElement=".clone-with-credential input"
                onDismiss={this.props.onDismiss}
                titleProps={{ text: Resources.ClonePanelTitle }}
            >
                <div className="flex-column flex-grow rhythm-vertical-24">
                    <FormItem label={Resources.CommandLineLabel}>
                        <div className="flex-row flex-grow flex-center">
                            <CloneWithCredential className="flex-grow" protocol={this.protocol} />
                        </div>
                    </FormItem>
                    <FormItem label={Resources.IDELabel}>
                        <CloneWithApplication />
                    </FormItem>
                    <CloneNotice />
                </div>
            </Panel>
        );
    }
}

Components.add("ms.vss-code-web.panel-clone", PanelClone);
